// src/pages/SellerIntelligence/GeographicOrders/GeographicOrders.js
//
// Geographic Order Intelligence.
//
// Only two of the PRD's five sub-features live here. SF1 (Order Density Map)
// and SF5 (Regional Product Preferences) are already delivered by Geographic
// Sales Intelligence and are deliberately not rebuilt — two maps of India
// disagreeing about which state matters most is worse than one. SF4 (Shipping
// Efficiency) is deferred because efficiency has no agreed definition here, and
// cost per order, cost as a share of order value and distance-normalised
// delivery time each rank regions differently.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiArrowUpRight } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import local from './GeographicOrders.module.css';
import { WindowControl, useWindowControl } from '../components/WindowControl';
import DeliveryTable from './components/DeliveryTable';
import ReturnsTable from './components/ReturnsTable';

const GeographicOrders = () => {
  const navigate = useNavigate();
  const control = useWindowControl();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/orders')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Geographic Order Intelligence</h1></div>
          <p>
            What delivery speed each part of India is promised, and from which
            fulfilment centre.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <WindowControl control={control} />

        {/* The two sub-features this page deliberately does not rebuild. Saying
            so is not enough on its own — a seller who came here looking for
            order density needs somewhere to go, not an explanation of why it is
            absent. */}
        <section className={local.card}>
          <div className={local.cardHead}>
            <h2 className={local.cardTitle}>Order density and regional product preference</h2>
          </div>
          <p className={local.muted}>
            Both live in Geographic Sales Intelligence and are not rebuilt here:
            two views of India disagreeing about which state matters most is
            worse than one.
          </p>
          <button
            type="button"
            className={local.segment}
            onClick={() => navigate('/dashboard/seller-intelligence/sales/geographic')}
          >
            Open Geographic Sales Intelligence <FiArrowUpRight />
          </button>
        </section>

        <DeliveryTable window={control.applied} onLoadingChange={control.track('deliveryTable')} />
        <ReturnsTable window={control.applied} onLoadingChange={control.track('returnsTable')} />
      </div>
    </div>
  );
};

export default GeographicOrders;
